import SecretLounge from "@src/pages/event/secretLounge/SecretLounge";
import SpringDayBride from "@src/pages/event/springDayBride/SpringDayBride";
import { lazy } from "react";

const RegistryShareEvent = lazy(() => import("../pages/event/kakaoShare/RegistryShareEvent"));
const MyWeddingGrandOpenPromotion = lazy(
  () => import("../pages/event/myWedding/MyWeddingGrandOpenPromotion"),
);
const DailyCheckInEvent = lazy(() => import("../pages/event/dailyCheckIn/DailyCheckIn"));

// TODO: 가능하면 이벤트 기간 주석으로 명시해서 나중에 필요 없을 때 지울 수 있도록 하기
export const eventRoutes = [
  // 이벤트 페이지 - 일시적인 페이지 (카카오 공유 이벤트 등록)
  { path: "/event/registry", element: <RegistryShareEvent /> }, // 20xx-xx-xx ~ 20xx-xx-xx

  // 마이웨딩 그랜드오픈 프로모션 이벤트 페이지
  // 이벤트는 종료되었으나, 기존에 뿌려둔 이벤트페이지 링크가 있어서 이벤트 종료되었다고 보여주고있음....
  { path: "/event/mywedding-grand-open", element: <MyWeddingGrandOpenPromotion /> }, // 20xx-xx-xx ~ 20xx-xx-xx

  // 4월 이벤트, 봄날의 신부에게 이벤트페이지
  { path: "/event/spring-day-bride", element: <SpringDayBride /> }, // 2025-04-01 ~ 2025-04-30

  // 시크릿 라운지 이벤트
  { path: "/event/secret-lounge", element: <SecretLounge /> }, // 2025-04 ~ 종료일 모름..

  // 6월 출석체크 이벤트, 추후 연장될 가능성 있음, 일단 6월
  { path: "/event/daily-check-in", element: <DailyCheckInEvent /> }, // 2025-06-01 ~ 2025-06-31
];
